import type { UiModule } from '@krp/client-runtime'
import { receiptsUiReducer, type ReceiptsUiState } from './reducer'
import { receiptsWindows } from './windows/registerWindows'
import { cashierAccessActions } from './features/cashier-access/model/actions'
import { cashierAnalyticsActions } from './features/cashier-analytics/model/actions'
import { cashierGroupsActions } from './features/cashier-groups/model/actions'
import { salesPointsActions } from './features/sales-points/model/actions'
import { ownCashiersActions } from './features/own-cashiers/model/actions'

export function createReceiptsUiModule(): UiModule<ReceiptsUiState> {
  return {
    id: 'receipts',
    reducer: receiptsUiReducer,
    slices: [
      { name: 'ownCashiers', lifetime: 'screen', reason: 'поиск по списку кассиров и показывать ли архивных; выбранный кассир — в адресе окна карточки, кассиры и коды сюда не попадают' },
      { name: 'cashierAccess', lifetime: 'screen', reason: 'выбранные источник и кассир на экране доступа и строка поиска; PIN и ответы службы не сохраняются' },
      { name: 'cashierGroups', lifetime: 'screen', reason: 'черновик связи кассиров и месяц окна связей; группы и кандидаты — в кэше запросов' },
      { name: 'cashierAnalytics', lifetime: 'screen', reason: 'выбранный общий кассир, диапазон, фильтры и вид графика отчёта; снимки и чеки только в кэше запросов' },
      { name: 'salesPoints', lifetime: 'screen', reason: 'выбранные дни и часовой пояс статистики группы касс; группы, кассы и итоги — только в кэше запросов' },
    ],
    windows: receiptsWindows,
    actions: [...ownCashiersActions, ...cashierAccessActions, ...cashierGroupsActions, ...cashierAnalyticsActions, ...salesPointsActions],
    persistence: [],
    listeners: [],
  }
}
